import odata from "@/core/api/mixin/odata";

export default {
  ...odata("scheduler_workers/report"),
};
